import Model from '@/Models/Contracts/Model';
import Store from '@/Models/Store';
import Review from '@/Models/Review';
import BudgetProjectionEntry from '@/Models/BudgetProjectionEntry';
export default class BudgetProjection extends Model {
    resource() {
        return 'budget-projections';
    }
    relations() {
        return {
            store: Store,
            entries: BudgetProjectionEntry,
            reviews: Review,
        };
    }
    relationships() {
        return {
            'store': this.hasMany(Store),
            'entries': this.hasMany(BudgetProjectionEntry),
        };
    }
}
